import { palette } from './palette';
import { commonThemeConfig } from '../common';

export const theme = {
    ...commonThemeConfig,
    palette,
};
